import React from 'react';
import { PrixReliability } from '../../types';

/**
 * Configuration visuelle de la pastille de fiabilité d'un prix DB.
 * Partagé entre BlockRow (prestation classique), VentilationCostRow
 * et DecompositionMOPanel (fourniture).
 */
export const RELIABILITY_DOT: Record<PrixReliability, { dot: string; label: string; reason: string }> = {
  high: {
    dot: 'bg-green-500',
    label: 'Fiable',
    reason: 'Nombreuses références · Écarts maîtrisés · Données récentes',
  },
  medium: {
    dot: 'bg-orange-400',
    label: 'Incertain',
    reason: 'Références limitées · Écarts modérés · Données partiellement récentes',
  },
  low: {
    dot: 'bg-red-500',
    label: 'Douteux',
    reason: 'Peu de références · Forts écarts de prix · Données trop anciennes',
  },
};

/** Mappe un nombre de sources actives à un niveau de fiabilité. */
export function sourcesToReliability(count: number): PrixReliability {
  if (count >= 5) return 'high';
  if (count >= 2) return 'medium';
  return 'low';
}

/** Couleur de texte associée à la fiabilité (utilisée dans les tooltips). */
export function reliabilityTextColor(rel: PrixReliability): string {
  return rel === 'high' ? 'text-green-400'
    : rel === 'medium' ? 'text-orange-400'
    : 'text-red-400';
}

/** Petit rond de couleur. */
export const ReliabilityDot: React.FC<{ reliability: PrixReliability; className?: string }> = ({
  reliability, className,
}) => (
  <span
    className={`inline-block w-2 h-2 rounded-full flex-shrink-0 ${RELIABILITY_DOT[reliability].dot} ${className ?? ''}`}
  />
);
